import React, { useEffect, useState } from "react";
import './CSS/AboutUs.css';


const AboutUs = ({ onBackToHome }) => {
  const [appear, setAppear] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Trigger appear animation after mount
    const timeout = setTimeout(() => {
      setAppear(true);
    }, 100);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="about-us-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-overlay"></div>
        <div className="container">
          <div className={`about-hero-content ${appear ? "appear" : ""}`}>
            <h1 className="hero-title">Once Here, Always Here...</h1>
            <p className="hero-description">
              Experience authentic flavors and homely warmth at Ali Darbar
            </p>
          </div>
        </div>
      </section>

      {/* Back Button */}
      <div className="container">
        <button className="back-btn" onClick={onBackToHome}>
          <i className="fas fa-arrow-left"></i>
          Back to Home
        </button>
      </div>

      {/* Main About Content */}
      <section className="about-main-section">
        <div className="container">
          <div className="section-title">
            <h2>About Us</h2>
            <div className="title-underline"></div>
          </div>

          <div className="about-content">
            <div className="about-text">
              <h3>Our Story</h3>
              <p>
                At <span className="highlight">Ali Darbar</span>, every dish is
                crafted with love, flavor, and care to give you a true family
                dining experience. From clay-pot biryanis and freshly made
                breads to our special Matka Gosht in Chicken and Mutton, each
                bite is prepared with authentic taste and homely warmth.
              </p>
              <p>
                Earlier, we introduced Nashik to{" "}
                <a href="https://www.instagram.com/rotiwaale/" style={{textDecoration: 'none' }} ><span className="highlight">ROTI WAALE</span></a>, a Naan (brand)
                known for serving the city's softest and most authentic Naans.
                The same signature Naans are now a proud part of Ali Darbar.
                Making your meals even more complete.
              </p>
              <div className="highlight-card">
                <p className="highlight-text">
                  👉 Good food, great taste, and the same Naan you already love,
                  now at Ali Darbar.
                </p>
              </div>
            </div>

            <div className="about-image">
              <div className="image-container">
                <img
                  src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1674&q=80"
                  alt="Ali Darbar Restaurant Interior"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Short About Section */}
      <section className="short-about-section">
        <div className="container">
          <div className="short-about-card">
            <div className="card-icon">
              <i className="fas fa-utensils"></i>
            </div>
            <h3>Ali Darbar Mini Family Restaurant</h3>
            <p>
              Serving authentic taste with love — from clay-pot biryanis to our
              signature Matka Gosht (Chicken & Mutton) and the softest rotis of
              Nashik from our brand Roti Waale.
            </p>
            <div className="highlight-card">
              <p className="highlight-text">
                👉 A true family dining experience, now all under one roof!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section className="vision-mission-section">
        <div className="container">
          <div className="section-title">
            <h2>Our Values</h2>
            <div className="title-underline"></div>
          </div>
          <div className="vm-grid">
            <div className="vision-card">
              <div className="card-header">
                <div className="icon-wrapper">
                  <i className="fas fa-eye"></i>
                </div>
                <h3>Our Vision</h3>
              </div>
              <p>
                To become Nashik's most trusted and loved family restaurant by
                blending authentic taste, homely warmth, and memorable dining
                experiences. We aim to carry forward our legacy of Roti Waale
                while creating a place where every family feels at home and
                every meal becomes a celebration.
              </p>
            </div>

            <div className="mission-card">
              <div className="card-header">
                <div className="icon-wrapper">
                  <i className="fas fa-bullseye"></i>
                </div>
                <h3>Our Mission</h3>
              </div>
              <ul className="mission-list">
                <li>
                  <i className="fas fa-check"></i>
                  To serve authentic, high-quality food prepared with care,
                  love, and hygiene.
                </li>
                <li>
                  <i className="fas fa-check"></i>
                  To preserve tradition with specialties like clay-pot biryanis
                  and Matka Gosht while offering modern comfort for families.
                </li>
                <li>
                  <i className="fas fa-check"></i>
                  To continue the legacy of Roti Waale by serving Nashik's
                  softest, most authentic rotis.
                </li>
                <li>
                  <i className="fas fa-check"></i>
                  To provide a cozy, family-friendly atmosphere where taste,
                  service, and togetherness come first.
                </li>
                <li>
                  <i className="fas fa-check"></i>
                  To make every visit affordable, memorable, and worth sharing.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <div className="section-title">
            <h2>Why Choose Us</h2>
            <div className="title-underline"></div>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-seedling"></i>
              </div>
              <h4>Fresh Ingredients</h4>
              <p>We use only the freshest ingredients in all our dishes</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-clock"></i>
              </div>
              <h4>Quick Service</h4>
              <p>Fast and efficient service without compromising quality</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-home"></i>
              </div>
              <h4>Homely Atmosphere</h4>
              <p>Experience the warmth of home in our restaurant</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-rupee-sign"></i>
              </div>
              <h4>Affordable Prices</h4>
              <p>Quality food at prices that won't break your budget</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
